(function () {
  var OKENDO_BASE = 'https://api.okendo.io/v1/stores/';

  function escapeHtml(text) {
    var el = document.createElement('span');
    el.textContent = text || '';
    return el.innerHTML;
  }

  function formatRelativeDate(dateString) {
    if (!dateString) return '';
    var date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    var now = new Date();
    var diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    if (diffDays < 1) return 'Today';
    if (diffDays === 1) return '1 day ago';
    if (diffDays < 30) return diffDays + ' days ago';
    var diffMonths = Math.floor(diffDays / 30);
    if (diffMonths === 1) return '1 month ago';
    if (diffMonths < 12) return diffMonths + ' months ago';
    var diffYears = Math.floor(diffMonths / 12);
    return diffYears === 1 ? '1 year ago' : diffYears + ' years ago';
  }

  function getReviewMedia(review) {
    if (!review.media || !review.media.length) return [];
    var productImg = (review.productImageUrl || '').replace(/\?.*$/, '');
    return review.media.filter(function (item) {
      var url = item.fullSizeUrl || item.largeUrl || item.thumbnailUrl || '';
      return url && url.replace(/\?.*$/, '') !== productImg;
    }).map(function (item) {
      return item.fullSizeUrl || item.largeUrl || item.thumbnailUrl;
    });
  }

  function getAllPhotos(reviews) {
    var photos = [];
    reviews.forEach(function (r) {
      getReviewMedia(r).forEach(function (url) {
        photos.push(url);
      });
    });
    return photos;
  }

  function renderStars(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill = i <= rating ? '#FFB800' : '#E0E0E0';
      html += '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 1l2.2 4.5 5 .7-3.6 3.5.8 5L8 12.7 3.6 14.7l.8-5-3.6-3.5 5-.7L8 1z" fill="' + fill + '"/></svg>';
    }
    return html;
  }

  function renderPhotosSection(photos) {
    if (!photos.length) return '';
    var html = '<span class="pdp-reviews__photos-label">Customer photos</span>';
    html += '<span class="pdp-reviews__photos-count">' + photos.length + '</span>';
    html += '<div class="pdp-reviews__photos-row">';
    photos.slice(0, 8).forEach(function (url) {
      html += '<img class="pdp-reviews__photos-thumb" src="' + escapeHtml(url) + '" alt="" width="48" height="48" loading="lazy">';
    });
    html += '</div>';
    return html;
  }

  function getReviewSubmissionUrl(okendoId, productId) {
    if (!okendoId || !productId) return '';
    return (
      'https://reviews.okendo.io/stores/' +
      encodeURIComponent(okendoId) +
      '/review?productId=shopify-' +
      encodeURIComponent(productId)
    );
  }

  function renderWriteReviewLink(className, writeUrl) {
    if (!writeUrl) {
      return '<span class="' + className + '" aria-disabled="true">Leave a review</span>';
    }
    return (
      '<a class="' + className + '" href="' + escapeHtml(writeUrl) + '" target="_blank" rel="noopener noreferrer">' +
        'Leave a review' +
      '</a>'
    );
  }

  function renderStats(reviews, displayTotal, writeUrl) {
    if (!reviews.length) return '';
    var total = displayTotal != null ? displayTotal : reviews.length;
    var sum = 0;
    var fiveStarCount = 0;
    reviews.forEach(function (r) {
      var rating = Number(r.rating) || 0;
      sum += rating;
      if (rating >= 4) fiveStarCount++;
    });
    var avg = (sum / reviews.length).toFixed(1);
    var recommendPct = Math.round((fiveStarCount / reviews.length) * 100);

    var html = '<div class="pdp-reviews__stats-left">';
    html += '<div class="pdp-reviews__stats-rating">';
    html += '<div class="pdp-reviews__stats-stars">' + renderStars(Math.round(avg)) + '<span class="pdp-reviews__stats-avg">' + avg + '/5</span></div>';
    html += '<span class="pdp-reviews__stats-count">(' + total + ' reviews)</span>';
    html += '</div>';
    html += '<div class="pdp-reviews__stats-meta">';
    html += '<div class="pdp-reviews__stats-recommend"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_836_1367)"><path d="M1.4465 18.9978C1.46483 19.6716 1.86175 20.2766 2.52038 20.4173C2.94342 20.5076 3.48517 20.5814 4.125 20.5814C4.76483 20.5814 5.30658 20.508 5.72917 20.4173C6.09361 20.3395 6.37793 20.1196 6.56242 19.8247C6.71157 19.5862 6.79551 19.2988 6.8035 18.9978C6.83421 17.8538 6.875 15.9178 6.875 13.7064C6.875 11.4949 6.83421 9.55891 6.8035 8.41537C6.78517 7.74162 6.38825 7.13662 5.72963 6.99591C5.20199 6.88503 4.66416 6.82988 4.125 6.83137C3.48517 6.83137 2.94342 6.90562 2.52083 6.99591C1.86175 7.13662 1.46437 7.74207 1.4465 8.41537C1.41579 9.55891 1.375 11.4949 1.375 13.7064C1.375 15.9178 1.41579 17.8538 1.4465 18.9978Z" fill="#180D0A"/><path d="M6.8035 18.9978C6.78562 19.6711 6.38825 20.2766 5.72917 20.4173C5.30658 20.508 4.76483 20.5814 4.125 20.5814C3.48517 20.5814 2.94342 20.5076 2.52037 20.4173C1.86175 20.2766 1.46483 19.6716 1.4465 18.9978C1.41579 17.8538 1.375 15.9178 1.375 13.7064C1.375 11.4949 1.41579 9.55891 1.4465 8.41537C1.46437 7.74207 1.86175 7.13662 2.52083 6.99591C2.94342 6.90562 3.48517 6.83137 4.125 6.83137C4.66416 6.82988 5.20199 6.88503 5.72962 6.99591C6.38825 7.13662 6.78517 7.74162 6.8035 8.41537C6.83421 9.55891 6.875 11.4949 6.875 13.7064C6.875 15.9178 6.83421 17.8538 6.8035 18.9978C6.79551 19.2988 6.71157 19.5862 6.56242 19.8247M5.72917 20.4173C6.09361 20.3395 6.37793 20.1196 6.56242 19.8247M6.76042 7.96574C7.50108 6.3437 8.34671 4.04791 8.77112 2.62707C9.00029 1.85937 9.69054 1.30937 10.4885 1.38132C10.9904 1.42624 11.5711 1.51103 12.1156 1.66687C13.0941 1.94737 13.6207 2.90895 13.6936 3.92462C13.7633 4.89857 13.7605 5.89041 13.728 6.76537C15.2162 6.62557 16.676 6.5142 17.9813 6.44637C19.3747 6.37349 20.542 7.41574 20.5947 8.80907C20.6928 11.3927 20.6122 15.5374 19.4242 18.7558C19.0094 19.8787 17.9039 20.547 16.7067 20.5722C12.8104 20.6547 8.85271 20.1721 6.56242 19.8247M4.125 17.8314V16.9147" stroke="#180D0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_836_1367"><rect width="22" height="22" fill="white"/></clipPath></defs></svg><span>' + recommendPct + '% recommend</span></div>';
    html += '</div>';
    html += '</div>';
    html += '<div class="pdp-reviews__stats-right">';
    html += renderWriteReviewLink('pdp-reviews__stats-write-btn', writeUrl);
    html += '</div>';
    return html;
  }

  function renderCard(review) {
    var rating = Number(review.rating) || 5;
    var author = (review.reviewer && (review.reviewer.displayName || review.reviewer.name)) || 'Customer';
    var date = formatRelativeDate(review.dateCreated);
    var body = review.body || '';
    var media = getReviewMedia(review);

    var html = '<div class="pdp-reviews__card">';
    html += '<div class="pdp-reviews__card-head">';
    html += '<div class="pdp-reviews__card-stars">' + renderStars(rating) + '</div>';
    html += '<span class="pdp-reviews__card-date">' + escapeHtml(date) + '</span>';
    html += '</div>';
    html += '<h4 class="pdp-reviews__card-author">' + escapeHtml(author) + '</h4>';

    if (body) {
      var truncated = body.length > 200;
      var displayText = truncated ? body.slice(0, 200) + '...' : body;
      html += '<p class="pdp-reviews__card-text" data-pdp-review-text>';
      html += '<span class="pdp-reviews__card-text-short">' + escapeHtml(displayText) + '</span>';
      if (truncated) {
        html += '<span class="pdp-reviews__card-text-full" hidden>' + escapeHtml(body) + '</span>';
        html += '<button class="pdp-reviews__card-more" type="button" data-pdp-review-toggle>SHOW MORE</button>';
      }
      html += '</p>';
    }

    if (media.length) {
      html += '<div class="pdp-reviews__card-media">';
      media.slice(0, 5).forEach(function (url) {
        html += '<img class="pdp-reviews__card-media-img" src="' + escapeHtml(url) + '" alt="" width="48" height="48" loading="lazy">';
      });
      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  function renderFooter() {
    return '<button class="pdp-reviews__show-all" type="button" data-pdp-reviews-show-all>Show all reviews <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="18" height="18" rx="9" fill="#151417"/><path d="M13 9H9M9 9H5M9 9V5M9 9V13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
  }

  function initShowMore(container) {
    container.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-pdp-review-toggle]');
      if (!toggle) return;

      var textEl = toggle.closest('[data-pdp-review-text]');
      if (!textEl) return;

      var shortEl = textEl.querySelector('.pdp-reviews__card-text-short');
      var fullEl = textEl.querySelector('.pdp-reviews__card-text-full');
      if (!shortEl || !fullEl) return;

      var isShowing = fullEl.hidden;
      shortEl.hidden = isShowing;
      fullEl.hidden = !isShowing;
      toggle.textContent = isShowing ? 'SHOW LESS' : 'SHOW MORE';
    });
  }

  function initSection(section) {
    var okendoId = (section.dataset.okendoId || '').trim();
    var productId = (section.dataset.productId || '').trim();
    var limit = Math.min(parseInt(section.dataset.reviewsLimit, 10) || 9, 9);
    var writeUrl = getReviewSubmissionUrl(okendoId, productId);

    if (!okendoId || !productId) return;

    var photosEl = section.querySelector('[data-pdp-reviews-photos]');
    var statsEl = section.querySelector('[data-pdp-reviews-stats]');
    var gridEl = section.querySelector('[data-pdp-reviews-grid]');
    var footerEl = section.querySelector('[data-pdp-reviews-footer]');

    var url = OKENDO_BASE + encodeURIComponent(okendoId) +
      '/products/shopify-' + productId + '/reviews?limit=25&orderBy=rating%20desc';

    var allReviews = [];
    var visibleCount = limit;
    var highStarTotal = null;

    function isHighStar(review) {
      return (Number(review.rating) || 0) >= 4;
    }

    function resolveNextUrl(nextUrl) {
      if (!nextUrl) return '';
      if (nextUrl.indexOf('http') === 0) return nextUrl;
      // Okendo returns paths like /stores/{id}/products/.../reviews?...
      if (nextUrl.indexOf('/stores/') === 0) {
        return 'https://api.okendo.io/v1' + nextUrl;
      }
      return OKENDO_BASE + encodeURIComponent(okendoId) + '/' + nextUrl.replace(/^\//, '');
    }

    function fetchAggregateCount() {
      var aggregateUrl = OKENDO_BASE + encodeURIComponent(okendoId) +
        '/products/shopify-' + productId + '/review_aggregate';
      return fetch(aggregateUrl)
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (data) {
          if (!data) return null;
          var aggregate = data.reviewAggregate || data;
          var byLevel = aggregate.reviewCountByLevel ||
            aggregate.ratingAndReviewCountByLevel ||
            {};
          var four = Number(byLevel.level4Count || byLevel.rating4 || byLevel['4'] || 0);
          var five = Number(byLevel.level5Count || byLevel.rating5 || byLevel['5'] || 0);
          if (four || five) return four + five;
          return null;
        })
        .catch(function () {
          return null;
        });
    }

    function renderGrid() {
      var html = '';
      allReviews.slice(0, visibleCount).forEach(function (r) {
        html += renderCard(r);
      });
      gridEl.innerHTML = html;
    }

    function fetchReviews(pageUrl, pages) {
      if (pages >= 40) return Promise.resolve();
      return fetch(pageUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var batch = data.reviews || data.list || [];
          if (!batch.length) return;

          var stop = false;
          batch.forEach(function (r) {
            if (stop) return;
            if (!isHighStar(r)) {
              stop = true;
              return;
            }
            allReviews.push(r);
          });

          var nextUrl = resolveNextUrl(data.nextUrl);
          if (!stop && nextUrl) {
            return fetchReviews(nextUrl, pages + 1);
          }
        })
        .catch(function (err) {
          console.warn('Reviews page fetch failed:', err);
        });
    }

    function bindShowAll() {
      if (!footerEl) return;
      if (allReviews.length > visibleCount) {
        footerEl.innerHTML = renderFooter();
        footerEl.style.display = '';
        var showAllBtn = footerEl.querySelector('[data-pdp-reviews-show-all]');
        if (showAllBtn) {
          showAllBtn.addEventListener('click', function () {
            visibleCount = allReviews.length;
            renderGrid();
            footerEl.style.display = 'none';
            initShowMore(gridEl);
          });
        }
      } else {
        footerEl.style.display = 'none';
      }
    }

    Promise.all([fetchReviews(url, 0), fetchAggregateCount()])
      .then(function (results) {
        highStarTotal = results[1];
        if (highStarTotal == null) highStarTotal = allReviews.length;

        if (!allReviews.length) {
          if (statsEl) statsEl.style.display = 'none';
          if (photosEl) photosEl.style.display = 'none';
          if (footerEl) footerEl.style.display = 'none';
          if (gridEl) {
            gridEl.innerHTML =
              '<div class="pdp-reviews__empty">' +
                '<h4 class="pdp-reviews__empty-title">No reviews yet</h4>' +
                '<p class="pdp-reviews__empty-text">Be the first to share your experience!</p>' +
                renderWriteReviewLink('pdp-reviews__write-btn', writeUrl) +
              '</div>';
          }
          return;
        }

        var photos = getAllPhotos(allReviews);
        if (photosEl) photosEl.innerHTML = renderPhotosSection(photos);
        if (statsEl) statsEl.innerHTML = renderStats(allReviews, highStarTotal, writeUrl);

        renderGrid();
        bindShowAll();
        initShowMore(gridEl);
      })
      .catch(function (err) {
        console.error('Reviews fetch error:', err);
        if (allReviews.length) {
          var photos = getAllPhotos(allReviews);
          if (photosEl) photosEl.innerHTML = renderPhotosSection(photos);
          if (statsEl) statsEl.innerHTML = renderStats(allReviews, allReviews.length, writeUrl);
          renderGrid();
          bindShowAll();
          initShowMore(gridEl);
        }
      });
  }

  document.querySelectorAll('[data-pdp-reviews]').forEach(initSection);
})();
